// Server-side pagination controls. total/page/limit from the list envelope.
export default function Pagination({ page, limit, total, onPage }) {
  const pages = Math.max(1, Math.ceil((total || 0) / limit));
  if (pages <= 1) return null;
  return (
    <div className="pagination">
      <button className="btn btn--ghost" disabled={page <= 1} onClick={() => onPage(page - 1)}>Prev</button>
      <span className="pagination__info">Page {page} of {pages} · {total} total</span>
      <button className="btn btn--ghost" disabled={page >= pages} onClick={() => onPage(page + 1)}>Next</button>
    </div>
  );
}
